var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filtro"},[_c('el-button',{class:_vm.classe,attrs:{"plain":""},on:{"click":function($event){return _vm.$emit('clickButton')}}},[_vm._v(" "+_vm._s(_vm.name)+" "),_c('i',{staticClass:"el-icon-arrow-down"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }